import React from 'react'
import { ButtonSkeleton } from '../../Skeletons/skeletonTemplates';
import {Link, useLocation} from 'react-router-dom'
import { gtagHelperFunction } from "../Shared Components/gtagHelperFunction"
import { setInitiatePayment,handleCaptureClick } from '../utils';


export default function RegistrationFloaterComponent(props) {
    var handleToUpdate = props.handleUpdate;
    var handleFillDetailsUpdate = props.handleFillDetailsUpdate;
    const {search} = useLocation()
    function handleRegisteredUser(record) {
        handleToUpdate(record)
        handleFillDetailsUpdate(record);      
    }    

    function fetchOnlineCourseButton() {
        if (!props.data.first_batch)
            return <div className="float-right"><ButtonSkeleton type = "btn-skeleton-sm" /></div>
        var record = {
            "batch_id" :  props.data.first_batch.batch_id,
            "batch_name" : props.data.first_batch.batch_name,
            "start_date" : props.data.first_batch.reg_start_date,
            "batch_slug": props.data.first_batch.batch_slug,
            "show_invite_code_block": props.data.first_batch.show_invite_code_block,
            "warning_message" : props.data.first_batch.warning_message
        }      
        var data = props.data.button_actions.register_btn
        var registerBtn = props.data.button_actions.register_btn;
        if ( registerBtn == null || Object.keys(registerBtn).length == 0){
            return (<button disabled className = "btn btn-success float-right sofia-pro reg-floater-btn">No Active Batches</button>);
        }
        var action = props.data.button_actions.register_btn.action
        var sub_action = props.data.button_actions.register_btn.sub_action
        var button;
        if (action === "user_already_registered_in_batch") {
            if (sub_action === "show_tracks")
                button = <a href = {props.data.button_actions.register_btn.extra.batch_url} className = "btn btn-success  float-right sofia-pro reg-floater-btn">Start Course</a>
            else if (sub_action === "fee_paid_batch_not_started")
                button = <button disabled className = "btn btn-success  float-right sofia-pro reg-floater-btn">Batch not Started</button>
            else if (sub_action === "subscribed") //to be discussed
                button = (<div>
                            <button  onClick = {() => {
                gtagHelperFunction("click","course_payfee_floating",window.location.href)
                handleRegisteredUser(record)
                setInitiatePayment()}}  className = "btn btn-success float-right sofia-pro reg-floater-btn">Pay Fee</button>
                        </div>
                        )
            else if (sub_action === "pay_fee")
                button = (<div>
                            <button  onClick = {() => {
                gtagHelperFunction("click","course_payfee_floating",window.location.href)
                handleRegisteredUser(record)
                setInitiatePayment()}}  className = "btn btn-success float-right sofia-pro pt-1 pb-1 reg-floater-btn">Pay Fee</button>
                          </div>
                        )
            else if (sub_action === "attend_contest")
                button = <a href = {data.extra.contest_url} className = "btn btn-success float-right sofia-pro reg-floater-btn">Attend Contest</a>
            else if (sub_action === "payment_link_will_open_on")
                button = <button disabled className = "btn btn-success  float-right sofia-pro reg-floater-btn">Payment Link opens on {data.extra.payment_start_date.split("T")[0]}</button>
            else if (sub_action === "payment_link_closed")
                button = <button disabled className = "btn btn-success  float-right sofia-pro reg-floater-btn">Payment Link Closed</button>
            else if (sub_action === "no_seats_available")
                button = <button disabled className = "btn btn-success  float-right sofia-pro reg-floater-btn">Seats not available</button>
            else if (sub_action === "registration_closed")
                button = <button disabled className = "btn btn-success  float-right sofia-pro reg-floater-btn">Registration Closed</button>
        } else if (action === "registration_not_started") {
            button = <button disabled className = "btn btn-success  float-right sofia-pro reg-floater-btn">Registration not started</button>
        } else if (action === "registration_closed") {
            button = <button disabled className = "btn btn-success  float-right sofia-pro reg-floater-btn">Registration Closed</button>
        } else if (action === "registration_open") {
            if (sub_action === "subscribe")
                button = <button onClick = {() => handleToUpdate(record)}  disabled className = "btn btn-success  float-right sofia-pro reg-floater-btn">Subscribe</button>
            else if (sub_action === "sign_up_now")
                button = <button onClick = {() => {
                    gtagHelperFunction("click","course_signup_floating",window.location.href)
                    handleToUpdate(record)
                }}  className = "btn btn-success float-right sofia-pro reg-floater-btn">Sign-Up Now</button>
            else if (sub_action === "login_to_subscribe")
                button = <a href = {`${window.location.href}?loginMode=${record.batch_id}`} className = "login-modal-btn btn btn-success  float-right sofia-pro reg-floater-btn">Login to Subscribe</a>    
            else if (sub_action === "login_to_register")
                button = <a href = {`${window.location.href}?loginMode=${record.batch_id}`} className = "login-modal-btn btn btn-success  float-right sofia-pro reg-floater-btn" onClick={()=>gtagHelperFunction("click","course_loginreg_floating",window.location.href)}>Login to Register</a>    
            else if (sub_action === "registration_closed")
                button = <button disabled className = "btn btn-success  float-right sofia-pro reg-floater-btn">Registration Closed</button>
            else if (sub_action === "free_course")
                button = <button onClick = {() => {
                gtagHelperFunction("click","course_reg_floating",window.location.href)
                handleToUpdate(record)}}  className = "btn btn-success float-right sofia-pro reg-floater-btn">Register Now</button>
        }
        return button;
    }

    function fetchLiveCourseButton() {
        if (props.hasBatch)
            return (<Link to = {{
                            pathname: `/payments/${props.courseSlug}`,
                            search : search
                            }} 
                    className = "btn btn-success float-right sofia-pro reg-floater-btn" onClick={() => {
                gtagHelperFunction("click","course_reg_top",window.location.href)
        }}>Register Now</Link>)
        else
            return (<button disabled className = "btn btn-danger float-right sofia-pro reg-floater-btn">No Active Batches</button>)    
    }

        /* Button to register for the contest */
    function fetchRegisterButton() {
        if (props.data.courseType === 1) {
            return fetchOnlineCourseButton() 
        } else {
            if (props.data.total_upcoming_batches === 1)
                return fetchOnlineCourseButton()
            return fetchLiveCourseButton()
        }
    }

    function downloAdSyllabusBtn (btnClass){
        return props.regFloaterData.broucher_link && <a
            className = {props.isLoggedIn ? `btn btn-success sofia-pro reg-floater-btn download-syllabus ${btnClass}` : `btn btn-success sofia-pro reg-floater-btn download-syllabus ${btnClass} login-modal-btn`}
            href={props.regFloaterData.broucher_link} target="_blank" onClick={() => {
                if(props.isLoggedIn) handleCaptureClick(props.courseSlug,'clicked_course_broucher')
            }}>
                <img src='https://media.geeksforgeeks.org/img-practice/download-1674474176.png' alt=""/>
                Course Brochure
            </a>
    }

    
    return (
        <section id = "floater-component" className = "floater-sticky hide">
            <div className = "card removeCardSpace1 col-12 col-sm-11 mx-auto ml-0 mr-0">
                <div className = "pt-3 pb-3 pl-3 pr-3">
                    <div className = "row my-auto">
                        <div className = "col-6 my-auto pl-0 pr-0">
                            <p className = {`font-weight-bold sofia-pro text-left floater-content mb-0 ${props.regFloaterData.broucher_link ? 'reg-floater-course-name' :''}`}>{props.data.course_name}</p>
                            {downloAdSyllabusBtn("download-syllabus-mob")}
                        </div>
                        <div className = "col-6 pl-0 pr-0">
                            {fetchRegisterButton()}
                            {downloAdSyllabusBtn("float-right download-syllabus-desktop")}
                        </div>
                    </div>
                </div>
            </div>    
        </section>
    )
}
